import { render, staticRenderFns } from "./AgendaNuovaRipartizioneModalComponent.vue?vue&type=template&id=e149ca62"
import script from "./AgendaNuovaRipartizioneModalComponent.vue?vue&type=script&lang=js"
export * from "./AgendaNuovaRipartizioneModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports